import React from 'react';

const MuseumIcon = (props) => {
  return (
    <img
      alt="Góra"
      src="/static/images/icons/tourist_attractions/museum.svg"
      {...props}
    />
  );
};

export default MuseumIcon;
